import { render, staticRenderFns } from "./transmissions.vue?vue&type=template&id=2b44cf9e&"
import script from "./transmissions.vue?vue&type=script&lang=js&"
export * from "./transmissions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports